"use client"

import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import * as React from "react";
import ReactPlayer from "react-player";
import {
  extendTailwindMerge
} from "tailwind-merge";
 
const AspectRatio = AspectRatioPrimitive.Root

const cn = extendTailwindMerge({
  separator: "_",
})


const Dialog = DialogPrimitive.Root
const DialogPortal = DialogPrimitive.Portal

const DialogOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({
  className, ...props 
}, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "data-[state=open]_animate-in data-[state=closed]_animate-out data-[state=closed]_fade-out-0 data-[state=open]_fade-in-0 fixed inset-0 z-[1000] bg-black/40",
      className
    )}
    {...props}
  />
))

DialogOverlay.displayName = DialogPrimitive.Overlay.displayName

const DialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({
  className, children, ...props 
}, ref) => (
  <DialogPortal>
    <DialogOverlay />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        "data-[state=open]_animate-in data-[state=closed]_animate-out data-[state=closed]_fade-out-0 data-[state=open]_fade-in-0 data-[state=closed]_zoom-out-95 data-[state=open]_zoom-in-95 data-[state=closed]_slide-out-to-left-1/2 data-[state=closed]_slide-out-to-top-[48%] data-[state=open]_slide-in-from-left-1/2 data-[state=open]_slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-[1100] translate-x-[-50%] translate-y-[-50%] duration-200 ",
        className
      )}
      {...props}
    >
      {children}
    </DialogPrimitive.Content>
  </DialogPortal>
))

DialogContent.displayName = DialogPrimitive.Content.displayName


const DialogTitle = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Title>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({
  className, ...props 
}, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className={cn(
      "text-lg font-semibold leading-none tracking-tight",
      className
    )}
    {...props}
  />
))

DialogTitle.displayName = DialogPrimitive.Title.displayName


const MeasuringVideoDialog = (props:{open:boolean, url:string, onOpenChange: (nextOpen:boolean) => void}) => {
  const {
    open, url, onOpenChange
  } = props;

  return (
    <Dialog open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent 
        className='lg_max-w-[1200px] max-h-full w-full max-w-[calc(100%_-_20px)] overflow-auto outline-0'
      >
        <AspectRatio ratio={16 / 9} >
          <ReactPlayer
            url={url}
            loop
            controls
            playbackRate={1}
            width='100%'
            height='100%'
            playsinline={false}
            playing
          />
        </AspectRatio>
        <div className='lg_pt-[35px] pt-[15px] text-center' onClick={() => { onOpenChange(false) }}>
          <button type='button'
            onClick={(e) => {
              e.stopPropagation();
              onOpenChange(false)
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='40'
              height='40'
              fill='none'
              viewBox='0 0 40 40'
              className='lg_w-10 lg_h-10 h-5 w-5'
            >
              <rect width='39' height='39' x='0.5' y='0.5' fill='#fff' rx='19.5' />
              <rect width='39' height='39' x='0.5' y='0.5' stroke='#fff' rx='19.5' />
              <path
                fill='#403732'
                d='m19.985 18.422 5.608-5.603a1.09 1.09 0 0 1 1.543.004l.046.046a1.1 1.1 0 0 1-.004 1.55l-5.603 5.6 5.54 5.563a1.1 1.1 0 0 1 0 1.55l-.047.047a1.09 1.09 0 0 1-1.543 0L19.98 21.61l-5.574 5.57a1.09 1.09 0 0 1-1.543-.005l-.046-.046a1.1 1.1 0 0 1 .004-1.55l5.57-5.566-5.572-5.596a1.1 1.1 0 0 1 0-1.55l.046-.047a1.09 1.09 0 0 1 1.543 0z'
              />
            </svg>
          </button>  
        </div>
      </DialogContent>
    </Dialog>
  )
};

export default MeasuringVideoDialog;
